import { AppEvents } from "@commoncore/utils/app-events";
import { IndexedDBModule } from "@mainrepo/app/core/database/IndexedDBManager";
import { VirtualMultiSelectLibrary } from "./VirtualMultiSelectUtil";
import { ActiveRepo } from "@commoncore/services/universal.service";
import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { ENV_CONSTANTS } from "@env-properties/environment";

declare var jQuery: any;
declare var $:any;

export class MultiSelectLibrary {
  universalService: any;
  contextMenuService: any;
  loggerService: any;
  dataArray:any = [];
  router:any;
  db: IndexedDBModule;
  shareAccessService:any;
  static singleInstance:any = null;
  static singleVirtualInstance:any = null;
  recalculateHeightService:any;
  public listService:any;
    constructor(public globalService){
      this.setEnvObjects(globalService);
      var self = this;
      AppEvents.multiSelectEvent.subscribe(response=>{
        self.dataArray = response["dataArray"];
      })
      document.addEventListener('long-press', function(e) {
        self.handleLongPressEvent();
      });
    }

    setEnvObjects(globalService){
      this.universalService = globalService.getUniversalServiceRef();
      this.contextMenuService = globalService.getContextMenuServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.db = IndexedDBModule.getInstance(globalService);
      this.router = globalService.getRouterRef();
      this.shareAccessService = this.globalService.getShareAccessServiceRef();
      this.recalculateHeightService = this.globalService.getContainerHeightCalculatorService();
      this.listService = globalService.getListServiceRef();
    }

  bindMultiSelectLibrary(itemContainer, activeItemClassName, itemClassName, isGridView,virtualGridEnabled,enableSingleSelect) {
  
    let universalServiceRef = this.universalService;
    let classRef = this;
    var contextMenuRef = this.contextMenuService;
    jQuery(itemContainer).unbind().multiSelect({
      
      actcls: activeItemClassName,
      selector: itemClassName,
      isGridView: isGridView,
      virtualGridEnabled : virtualGridEnabled,
      enableSingleSelect : enableSingleSelect,
      callback: function(items, isSelectAll) { 
        if(universalServiceRef.showPreview) return;
        var objId;
          universalServiceRef.showAutoSuggestion = false;
          if( (universalServiceRef.popUpToBeOpened == "addToAlbum" || universalServiceRef.popUpToBeOpened == "movePopUp" ||  universalServiceRef.popUpToBeOpened == "copyPopUp") 
              && (universalServiceRef.showCreateFolderModal || universalServiceRef.showCreateAlbumModal) || (universalServiceRef.showEnhancedShareLink && $('#share-modal').is(':visible'))){
            return;
          }
          if(isSelectAll != undefined && isSelectAll==true && enableSingleSelect){
            jQuery(".tab-content").find(".grid_info").removeClass("grid_info");
            jQuery(".tab-content").find(".list_info").removeClass("list_info");
            return;
          }
          if(itemContainer=='#recently-uploaded-filter-section' && !universalServiceRef.fetchAllRecentFiles) {
            universalServiceRef.isHorizontalRecentFileAccessedForPreview = true;
            if(event.type != 'contextmenu' && universalServiceRef.mobileSelectionModeOn) {
              jQuery("#recentFilesMainWrapper").find(".grid_info").removeClass("grid_info");
              jQuery("#recentFilesMainWrapper").find(".list_info").removeClass("list_info");
              return false;
            }
            if(!isGridView) {
              if(classRef.listService.listOptions.api){
                universalServiceRef.isRecentPanelSelected = true;
                classRef.listService.listOptions.api.deselectAll();
              }
            } else {
              universalServiceRef.isRecentPanelSelected = false;
            }
            // $('.ag-checked').removeClass('ag-checked');
            // $('.ag-row-selected').removeClass('ag-row-selected');
          } else {
            universalServiceRef.isHorizontalRecentFileAccessedForPreview = false;
          }
          universalServiceRef.selectedNodes = [];
          universalServiceRef.hideEditAlbumDescBox = true;
          universalServiceRef.hideEditAlbumNameBox = true;
          jQuery.each(items, function(index, item) {
            objId = jQuery(item).attr("id");
            var object = "";
            if(objId.indexOf('recent_') > -1) {
              object = classRef.getObjectMetadata(objId.split('_')[1]);
            } else {
              object = classRef.getObjectMetadata(objId);
            }
            if(object["isBackupDevices"]== 'Y'){
              if(universalServiceRef.currentSelectedDevice.length == 1) {
                universalServiceRef.currentSelectedDevice = [];
                $('.gridItem').removeClass('grid_info');
                var closestDivId = $(event.target).closest('div').attr('id');
                var el = document.getElementById(closestDivId);
                el.classList.add('grid_info');
                object = classRef.getObjectMetadata(closestDivId);
                universalServiceRef.currentSelectedDevice.push(object);
                universalServiceRef.selectedNodes.push(object);
                return false;
              } 
            }
            universalServiceRef.currentSelectedDevice.push(object);

            universalServiceRef.selectedNodes.push(object);
            universalServiceRef.openMoreOptions = false;
          });
          if(universalServiceRef.selectedNodes.length>0){
            if(universalServiceRef.selectedNodes.length == 1){
              universalServiceRef.selectedFile = universalServiceRef.selectedNodes[0];
            }
            contextMenuRef.decideContextMenuItems();
          }
          if(universalServiceRef.selectedNodes.length == 0) {
            universalServiceRef.selectedNodes = [];
            universalServiceRef.showTopMenu = false;
            universalServiceRef.hideTopMenuOptions();
            if(universalServiceRef.showTopMenu == false){
              // jQuery(".left-icon-set .left-icon-set").hide();
              jQuery( ".left-icon-set .NeueSort" ).prop( "disabled", false );
              jQuery( ".left-icon-set .NeueA-Z" ).prop( "disabled", false );
              jQuery( ".left-icon-set .NeueListView" ).prop( "disabled", false );
            }
            universalServiceRef.showContextMenu = false;
            if(!universalServiceRef.selectedFile) {
              universalServiceRef.showMobOptionMenu = false;
            }
            universalServiceRef.showFileInfo = false;
            universalServiceRef.isDesktopSelectionModeOn = false;
            $(".highlight-recent-item").removeClass("highlight-recent-item");
            contextMenuRef.decideContextMenuItems()
            setTimeout(() => {
              classRef.recalculateHeightService.sendRecalculateEventToComponents(true);
            }, 10);
            return false;
          }

          if(universalServiceRef.showTopMenu == true || universalServiceRef.emptyFolder == true){
            if(universalServiceRef.showTopMenu == true && universalServiceRef.selectedNodes.length>0){
              // jQuery(".left-icon-set").show();
            }
            jQuery( ".left-icon-set .NeueSort" ).prop( "disabled", true );
            jQuery( ".left-icon-set .NeueA-Z" ).prop( "disabled", true );
            jQuery( ".left-icon-set .NeueListView" ).prop( "disabled", true );
          }

          if(universalServiceRef.selectedNodes.length == 1) {
            universalServiceRef.selectedFile = universalServiceRef.selectedNodes[0];            
            if(universalServiceRef.isMobileDevice) {
              if(event != undefined && jQuery(event.target).attr("class") != undefined && jQuery(event.target).attr("class").indexOf("NeueMore_Options") != -1) {
                universalServiceRef.showMobOptionMenu = true;
              }
            }

            $(window).on('hidden.bs.modal', function() { 
              universalServiceRef.selectedNodes = [];

              $('.listItem').removeClass('list_info');
              $('.gridItem').removeClass('grid_info');
              
              universalServiceRef.showMobOptionMenu = false;
            });
            setTimeout(() => {
              classRef.recalculateHeightService.sendRecalculateEventToComponents(true);
            }, 10);
          }

          if(universalServiceRef.showFileInfo){
            universalServiceRef.showFileInfo = false;
          }

          if(universalServiceRef.selectedNodes.length > 1){
            universalServiceRef.showFileInfo = false;

            if(!universalServiceRef.isMobileDevice) {
              universalServiceRef.isDesktopSelectionModeOn = true;
            }
          }
          universalServiceRef.isFolderPresent(); 
          universalServiceRef.showTopMenu = true; 
          universalServiceRef.showTopMenuOptions();
          jQuery("#customContextMenu").hide();

           universalServiceRef.subject.next(universalServiceRef.selectedNodes.length);
          
          if(universalServiceRef.selectedNodes.length === 1) {
            universalServiceRef.openMoreOptions = false;
            // if(itemContainer == '#semanticWrapperId' && !universalServiceRef.isMobileDevice){
            //   $('#'+objId).find('.thumb-img-holder').addClass('highlight-recent-item');
            // }
            if(universalServiceRef.selectedNodes[0].horizontalPanelItem == false || universalServiceRef.selectedNodes[0].horizontalPanelItem == undefined){
              if(event.type == 'contextmenu') {
                
                contextMenuRef.showCustomContextMenu(event); 
                if(enableSingleSelect) {
                  // universalServiceRef.showTopMenu = false;
                  // universalServiceRef.hideTopMenuOptions();
                  jQuery(".tab-content").find(".grid_info").removeClass("grid_info");
                  jQuery(".tab-content").find(".list_info").removeClass("list_info");
                  $(itemContainer + ' #'+objId).find('.thumb-img-holder').addClass('highlight-recent-item');
                  universalServiceRef.isDesktopSelectionModeOn = false;
                }
                return false;
              } else if(enableSingleSelect && event.type == 'click') {
                universalServiceRef.isDesktopSelectionModeOn = false;
              }
            }else{
              universalServiceRef.showTopMenu = false; 
              universalServiceRef.hideTopMenuOptions();  
            }
          }
      }
    });
  }
  bindMultiSelectUIevent(itemContainer, itemClassName) {
    let classRef = this;
    var universalServiceRef = this.universalService;    
    var contextMenuRef = this.contextMenuService;
    jQuery(itemContainer).off().on('click', itemClassName, function(e) {
        if ((!universalServiceRef.isDesktopSelectionModeOn && !universalServiceRef.mobileSelectionModeOn) && universalServiceRef.selectedNodes.length == 1 && universalServiceRef.selectedNodes[0].objectType != 'FR' && universalServiceRef.selectedNodes[0].objectType != 'BR'&& !$('#add-to-jiocloud-modal').is(':visible')) {
     
          if(classRef.universalService.isUserOnSharedLinkByMe || universalServiceRef.currentTab == "Trash" || universalServiceRef.currentTab == "tftrash"){
            return;
          }
          if(universalServiceRef.isHorizontalRecentFileAccessedForPreview) {
            universalServiceRef.recentFilesDataPreview = true;
          }
          universalServiceRef.openPreview(universalServiceRef.selectedNodes[0]);
          classRef.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file

          setTimeout(()=>{
            
            contextMenuRef.decideContextMenuItems();
          },500)
          
        }
        this.showContextMenu = false;
        jQuery("#customContextMenu").hide();
    });
  
    $(itemContainer).on('contextmenu', itemClassName, function(e) {  
      if(universalServiceRef.selectedNodes.length != 0 && (universalServiceRef.selectedNodes[0].horizontalPanelItem == false || universalServiceRef.selectedNodes[0].horizontalPanelItem == undefined)){
        
        contextMenuRef.showCustomContextMenu(e);   
        universalServiceRef.showTopMenu = true; 
        universalServiceRef.showTopMenuOptions();
      }else{
        universalServiceRef.openMoreOptions = false;
        universalServiceRef.showTopMenu = false; 
        universalServiceRef.hideTopMenuOptions();
      } 
    });
  }

  getObjectMetadata(id){
    var data;
    if(this.router.url.includes('/digilocker/') || this.router.url.includes('/albums/') || this.universalService.activeRepo == 'invite' || (!window.location.href.includes("?u") && this.universalService.activeRepo == 'share')){
      this.dataArray.map(obj=>{
          if(obj["objectKey"] == id)
            data =  obj;
      })
    }else{
      this.dataArray.map(month=>{
        if(month["objects"]){
          month["objects"]?.map(obj=>{
            if(obj["objectKey"] == id)
              data =  obj;
          })
        }else{
          if(month["objectKey"] == id)
            data =  month;
        }
      })
    }

    if(!data){
      data = this.universalService.foldersArray.find(folder=>folder["objectKey"] == id)
      if(!data) {//On recent files selection criteria
        data = this.universalService.recentFilesPreviewArray.find(file=>file["objectKey"] == id)
      }
    }
    return data?data:{};
  }

  public static getInstance(globalService){
    let universalServiceRef = globalService?.getUniversalServiceRef()
    if(universalServiceRef.virtualGridEnabled){
      if(this.singleVirtualInstance == null){
        this.singleVirtualInstance = new VirtualMultiSelectLibrary(globalService);
        return this.singleVirtualInstance;
      }else{
        return this.singleVirtualInstance;
      }
    }else{
      if(this.singleInstance == null){
        this.singleInstance = new MultiSelectLibrary(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }
  }

  handleLongPressEvent() {
    let universalServiceRef = this.universalService;
    if(!universalServiceRef.isMobileDevice) return;
    $(".highlight-recent-item").removeClass("highlight-recent-item");
    universalServiceRef.selectedNodes =[];
    universalServiceRef.openMoreOptions = false;
    universalServiceRef.showTopMenu = false; 
    universalServiceRef.hideTopMenuOptions();
  }
}


